import { Box } from '@mui/material';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { protoIcon } from '../common/ProtoIcon';

/**
 * Casca das telas públicas/de acesso no mobile (login, redefinir senha,
 * ativação, 404, termos, privacidade) — `prototipos-mobile/auth/*.html`.
 * Barra superior `.appbar` (opcional, `data-nobar` no protótipo) + `.content`
 * (padding 16/16/28). Só apresentação.
 */
const BackIcon = protoIcon('back');

// `.icon-btn` — botão 40x40 da barra superior
export const AUTH_ICON_BTN_SX = {
    width: 40,
    height: 40,
    borderRadius: '12px',
    border: 0,
    background: 'none',
    p: 0,
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: 'text.secondary',
    flexShrink: 0,
    cursor: 'pointer',
    '&:active': { backgroundColor: 'background.subtle' },
};

export function MobileAuthPage({ title, sub, onBack, backTo, noBar, children }) {
    const navigate = useNavigate();
    const handleBack = onBack || (() => navigate(backTo));
    return (
        <Box sx={{ minHeight: '100dvh', display: 'flex', flexDirection: 'column', backgroundColor: 'background.default', color: 'text.primary', fontSize: 14, lineHeight: 1.4 }}>
            {!noBar && (
                <Box
                    component="header"
                    sx={{
                        flexShrink: 0,
                        display: 'flex',
                        alignItems: 'center',
                        gap: '6px',
                        p: 'calc(10px + env(safe-area-inset-top, 0px)) 12px 10px',
                        backgroundColor: 'background.paper',
                        borderBottom: '1px solid',
                        borderColor: 'divider',
                        minHeight: 56,
                        boxSizing: 'border-box',
                        position: 'sticky',
                        top: 0,
                        zIndex: 5,
                    }}
                >
                    {(onBack || backTo) && (
                        <Box component="button" type="button" aria-label="Voltar" onClick={handleBack} sx={AUTH_ICON_BTN_SX}>
                            <BackIcon size={20} />
                        </Box>
                    )}
                    <Box sx={{ flex: 1, minWidth: 0 }}>
                        <Box component="h1" sx={{ m: 0, fontSize: 17, fontWeight: 800, letterSpacing: '-.01em', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', lineHeight: 1.4 }}>{title}</Box>
                        {sub && <Box sx={{ fontSize: 11.5, color: 'text.disabled', mt: '1px' }}>{sub}</Box>}
                    </Box>
                </Box>
            )}
            <Box sx={{ flex: 1, minWidth: 0, p: '16px 16px 28px', boxSizing: 'border-box' }}>{children}</Box>
        </Box>
    );
}

// `.check` — linha com caixa de seleção de 22px (accent-color da marca)
export function AuthCheck({ checked, onChange, children, sx }) {
    return (
        <Box component="label" sx={{ display: 'flex', alignItems: 'center', gap: '12px', p: '12px 0', fontWeight: 600, ...sx }}>
            <Box
                component="input"
                type="checkbox"
                checked={checked}
                onChange={onChange}
                sx={{ width: 22, height: 22, m: 0, flexShrink: 0, accentColor: (t) => t.palette.primary.main }}
            />
            {children}
        </Box>
    );
}

// `.link`
export const authLinkSx = { color: 'primary.main', fontWeight: 700, fontSize: 13, textDecoration: 'none', background: 'none', border: 0, p: 0, cursor: 'pointer', fontFamily: 'inherit' };
